<div class="contact-wrapper content-wrapper" *ngIf="showBanner">
  <img class="logo" [src]="banner?.image?.data?.attributes?.url" />

  <div class="body">
    <h2 class="banner-title">{{ banner?.title }}</h2>

    <p class="excerpt">{{ banner?.excerpt }}</p>

    <button (click)="navigate()" class="button">
      {{ banner?.cta_text }}
    </button>
  </div>
</div>
